import React from 'react';
import { cn } from '../../lib/utils';

export function StatsCard({ title, value, icon: Icon, trend, trendLabel, className, accentColor = false }) {
    return (
        <div
            className={cn(
                'bg-white border border-border/60 shadow-[0_2px_4px_rgba(0,0,0,0.02)] p-6 rounded-lg',
                'hover:shadow-[0_8px_16px_rgba(0,0,0,0.04)] transition-all duration-300',
                accentColor && 'border-t-4 border-t-primary',
                className
            )}
            data-testid={`stats-card-${title?.toLowerCase().replace(/\s+/g, '-')}`}
        >
            <div className="flex items-center justify-between">
                <div>
                    <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
                        {title}
                    </p>
                    <p className="mt-2 text-3xl font-bold font-heading text-foreground">
                        {value}
                    </p>
                    {trend !== undefined && (
                        <p className={cn(
                            'mt-1 text-sm',
                            trend > 0 ? 'text-emerald-600' : trend < 0 ? 'text-red-600' : 'text-muted-foreground'
                        )}>
                            {trend > 0 ? '+' : ''}{trend}% {trendLabel}
                        </p>
                    )}
                </div>
                {Icon && (
                    <div className="p-3 bg-muted rounded-lg">
                        <Icon className="h-6 w-6 text-muted-foreground" />
                    </div>
                )}
            </div>
        </div>
    );
}
